import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes, mapToCanActivate } from '@angular/router';
import { HomeComponent } from './Home/home.component';
import { AuthGuard } from './identity/authGuard';
import { ApiFrameComponent } from './apiFrame.component';
import { standaloneRoutes } from './standalone-routes';
import { GroupMeChatComponent } from './groupme-chat/groupme-chat.component';

const routes: Routes = [
  {
    path: 'identity',
    loadChildren: () => import('./identity/identity.module').then(m => m.IdentityModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'apiFrame',
    component: ApiFrameComponent,
  },
  {
    path: '',
    pathMatch: 'prefix',
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent
      }
    ]
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'groupme-chat',
    component: GroupMeChatComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dashboards',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardsModule),
    canActivateChild: [AuthGuard]
  },
  {
    path: 'internalb29',
    loadChildren: () => import('./dashboard-internal/dashboard-internal.module').then(m => m.DashboardsModule),
    canActivateChild: [AuthGuard]
  },
    {
        path: 'telerik-reporting',
        loadChildren: () => import('./telerik-reporting/telerik-reporting.module').then(m => m.TelerikReportingModule),
        canActivate: mapToCanActivate([AuthGuard])
    },
    ...standaloneRoutes
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
